import { createAction } from 'redux-actions';

const types = {
  STATUS_CODE_ANALYTICS: 'STATUS_CODE_ANALYTICS',
  TRACK_OPEN_SCREEN: 'TRACK_OPEN_SCREEN',
  RECEIVED_FIRST_BYTE: 'RECEIVED_FIRST_BYTE',
  FIRST_RENDER: 'FIRST_RENDER',
  RECEIVE_API_RESPONSE: 'RECEIVE_API_RESPONSE',
  BATCH_CONTENT_DOWNLOAD: 'BATCH_CONTENT_DOWNLOAD',
  CONTENT_DOWNLOAD_COMPLETED: 'CONTENT_DOWNLOAD_COMPLETED',
  UPDATE_BATCH_CONTENT_DOWNLOAD: 'UPDATE_BATCH_CONTENT_DOWNLOAD',
  BATCH_CONTENT_DOWNLOAD_COMPLETED: 'BATCH_CONTENT_DOWNLOAD_COMPLETED',
  FULL_PAGE_INTERACTABLE: 'FULL_PAGE_INTERACTABLE',
  HOTEL_SEARCH_INIT: 'HOTEL_SEARCH_INIT',
  HOTEL_SELECT_HOTEL: 'HOTEL_SELECT_HOTEL',
  HOTEL_SELECT_ROOM: 'HOTEL_SELECT_ROOM',
  HOTEL_ROOM_VIEW: 'HOTEL_ROOM_VIEW',
  HOTEL_GUEST_DETAIL_SUBMIT: 'HOTEL_GUEST_DETAIL_SUBMIT',
  HOTEL_PAYMENT_SUCCESS: 'HOTEL_PAYMENT_SUCCESS',
  HOTEL_SEARCH_WIDGET: 'HOTEL_SEARCH_WIDGET',
  ERROR_POP_OUT: 'ERROR_POP_OUT',
  SEARCH_AGAIN: 'SEARCH_AGAIN',
  NO_HOTELS: 'NO_HOTELS',
  VIEW_IMAGE_BANNER: 'VIEW_IMAGE_BANNER',
  VIEW_ROOM: 'VIEW_ROOM',
};

const actionCreators = {
  trackStatusCode: createAction(types.STATUS_CODE_ANALYTICS),
  trackOpenScreen: createAction(types.TRACK_OPEN_SCREEN),
  trackReceivedFirstByte: createAction(types.RECEIVED_FIRST_BYTE),
  trackFirstRender: createAction(types.FIRST_RENDER),
  trackReceiveApiResponse: createAction(types.RECEIVE_API_RESPONSE),
  trackBatchContentDownload: createAction(types.BATCH_CONTENT_DOWNLOAD),
  trackContentDownloadCompleted: createAction(types.CONTENT_DOWNLOAD_COMPLETED),
  updateBatchContentDownload: createAction(types.UPDATE_BATCH_CONTENT_DOWNLOAD),
  trackBatchContentDownloadCompleted: createAction(
    types.BATCH_CONTENT_DOWNLOAD_COMPLETED
  ),
  trackFullPageInteractable: createAction(types.FULL_PAGE_INTERACTABLE),
  trackSearchInit: createAction(types.HOTEL_SEARCH_INIT),
  trackSelectHotel: createAction(types.HOTEL_SELECT_HOTEL),
  tractSelectRoom: createAction(types.HOTEL_SELECT_ROOM),
  trackViewRoom: createAction(types.HOTEL_ROOM_VIEW),
  trackGuestDetailSubmited: createAction(types.HOTEL_GUEST_DETAIL_SUBMIT),
  trackPaymentSuccess: createAction(types.HOTEL_PAYMENT_SUCCESS),
  trackHotelSearchWidget: createAction(types.HOTEL_SEARCH_WIDGET),
  trackErrorPopOut: createAction(types.ERROR_POP_OUT),
  trackSearchAgain: createAction(types.SEARCH_AGAIN),
  trackNoHotels: createAction(types.NO_HOTELS),
  trackViewImageBanner: createAction(types.VIEW_IMAGE_BANNER),
  trackViewRoom: createAction(types.VIEW_ROOM),
};

export { types, actionCreators };
